import React, { Component } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

class FiveBarHistogram extends Component {
  render() {
    const { cat1, val1, cat2, val2, cat3, val3, cat4, val4, cat5, val5 } =
      this.props;

    const labels = [];
    const values = [];

    const add = (cat, val) => {
      if (cat && typeof val === "number") {
        labels.push(cat);
        values.push(val);
      }
    };

    add(cat1, val1);
    add(cat2, val2);
    add(cat3, val3);
    add(cat4, val4);
    add(cat5, val5);

    if (labels.length === 0) {
      return null;
    }

    const data = {
      labels,
      datasets: [
        {
          label: "Values",
          data: values,
          backgroundColor: "rgba(75,192,192,0.6)",
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false, // 🔥 critical for mobile
      plugins: {
        legend: {
          display: false,
        },
      },
      scales: {
        y: {
          beginAtZero: true,
        },
      },
    };

    return (
      <div
        style={{
          width: "100%",
          maxWidth: "800px",
          height: "300px", // Desktop default
          margin: "0 auto",
        }}
      >
        <Bar data={data} options={options} />
      </div>
    );
  }
}

export default FiveBarHistogram;

////////////////////////////////////////////////////////////////////////////////////////////
// import React, { Component } from "react";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { Bar } from "react-chartjs-2";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// );

// class FiveBarHistogram extends Component {
//   buildChartData() {
//     const {
//       cat1, val1,
//       cat2, val2,
//       cat3, val3,
//       cat4, val4,
//       cat5, val5,
//     } = this.props;

//     const categories = [];
//     const values = [];

//     // Helper function
//     const addBar = (cat, val) => {
//       if (cat && val !== undefined && val !== null) {
//         categories.push(cat);
//         values.push(val);
//       }
//     };

//     addBar(cat1, val1);
//     addBar(cat2, val2);
//     addBar(cat3, val3);
//     addBar(cat4, val4);
//     addBar(cat5, val5);

//     return {
//       labels: categories,
//       datasets: [
//         {
//           label: "Values",
//           data: values,
//           backgroundColor: [
//             "rgba(75,192,192,0.6)",
//             "rgba(153,102,255,0.6)",
//             "rgba(255,159,64,0.6)",
//             "rgba(255,99,132,0.6)",
//             "rgba(54,162,235,0.6)",
//           ].slice(0, values.length),
//           borderWidth: 1,
//         },
//       ],
//     };
//   }

//   render() {
//     const chartData = this.buildChartData();

//     if (!chartData.labels.length) {
//       return null; // Prevent render if nothing exists yet
//     }

//     const options = {
//       responsive: true,
//       scales: {
//         y: {
//           beginAtZero: true,
//         },
//       },
//     };

//     return (
//       <div style={{ width: "600px", margin: "0 auto" }}>
//         <Bar data={chartData} options={options} />
//       </div>
//     );
//   }
// }

// export default FiveBarHistogram;
